import { NativeSelect, NativeSelectProps } from '@mui/material';
import { Field, FieldProps } from 'formik';

export const CustomSelect = ({
  onChange,
  onBlur,
  children,
  ...propsRest
}: NativeSelectProps) => {
  return (
    <Field name={propsRest.name}>
      {({ field, form: { touched, errors } }: FieldProps) => (
        <NativeSelect
          {...propsRest}
          {...field}
          onChange={e => {
            field.onChange(e);
            if (onChange) onChange(e);
          }}
          onBlur={e => {
            field.onBlur(e);
            if (onBlur) onBlur(e);
          }}
          error={touched[field.name] && Boolean(errors[field.name])}
        >
          {children}
        </NativeSelect>
      )}
    </Field>
  );
};
